// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getRoute = () => window.location.pathname.replace(/feature\/(.*?)\//, "");
